import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
import '../Card/card-style.css';
import FormContainer from '../components/FormContainer.jsx';
import config from '../appconfig/config.json';

const InvalidApplication = (props) => {
    const [prodType,setProdType]  = useState();

    useEffect(() => {
        window.scrollTo(0,0);
        setProdType(storage.getProductType());
        storage.clearAll();
     }, []);

     const handleOnClick = () => {
        window.location.href = config.link.Cancle;
    }
    const handleCancel = () => {
        window.close();
    }

    return(
        <FormContainer>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{'Oops!'}</legend>
            </div>
        </div>
        <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
        <br/>     
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={'lmsg2'} style={{textAlign:'center',fontSize:'1.3em',fontWeight:'600'}}>{'Your application has expired. Please reapply.'}</div>
            </div>
        </div>
     
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ padding: "20px",textAlign:'center'}}>
                <button type={'submit'} className="k-button btn btn-success" onClick={handleOnClick}>{'Apply Now'}</button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type={'button'} className="k-button btn-back" onClick={handleCancel}>{'Cancel'}</button>
            </div>
        </div> 
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={'lmsg1'} style={{textAlign:'center'}}>{'For queries, get in touch at'}<br/>{'1800-MAYBANK (1800-629 2265) or (65) 6533 5229 (Overseas) '}</div>
            </div>
        </div> 
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={'lmsg1'} style={{textAlign:'center'}}>{'Note: You may also visit any nearest Maybank Branch to apply'}</div>
            </div>
        </div> 
        <div style={{textAlign:'center',padding:'10px'}}>
            <a href={config.link.branchLocator} className="txtBlue fbaPSize"> {'Click here for branch locator'}</a>
        </div>
        <br/> 
    </FormContainer>
    )
}

export default InvalidApplication;